import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import axiosInstance from "../../../helpers/axiosInstance";

const ProfileMenu = ({ t }) => {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();

  const toggle = () => {
    setMenu((prevState) => !prevState);
  };

  const getUsername = () => {
    try {
      if (localStorage.getItem("user")) {
        const obj = JSON.parse(localStorage.getItem("user"));
        const uNm = obj.name.split("@")[0];
        return uNm.charAt(0).toUpperCase() + uNm.slice(1);
      }
      return "Admin";
    } catch (error) {
      console.error("Error parsing user data:", error);
      return "Admin";
    }
  };

  const handleLogout = async () => {
    try {
      localStorage.removeItem("authUser");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      localStorage.clear();
      navigate("/login");
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={toggle}
        className="d-inline-block user-dropdown"
      >
        <DropdownToggle
          tag="button"
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
        >
          <img
            className="rounded-circle header-profile-user me-1"
            src={"/logo.png"}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-1 text-transform">
            {getUsername()}
          </span>
          <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem onClick={handleLogout} className="text-danger">
            <i className="ri-shut-down-line align-middle me-1 text-danger"></i>
            {t("Logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(ProfileMenu);
